import { Component, forwardRef, OnInit, OnDestroy, OnChanges } from '@angular/core';

import { Subscription } from 'rxjs';

import { MonitorConfigService } from '../../../MonitorShared/services/monitor-config.service';
import { CheckboxOptionModel } from '../../../Forms/models/checkbox-option.model';
import { AbstractFormFieldComponent } from '../../../PageBuilder/components/FormField/abstract-form-field.component';
import { CheckboxesFieldComponent } from '../../../PageBuilder/components/FormFields/CheckboxesField/checkboxes-field.component';

import { MediaTypeEnum } from '@Common/Basic/enums/media-type.enum';

@Component({
    selector: 'agpr-chart-network-checkbox-field',
    templateUrl: './chart-network-checkbox-field.component.html',
    styleUrls: ['./chart-network-checkbox-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => ChartNetworkCheckboxFieldComponent)
        }
    ],
    standalone: false
})
export class ChartNetworkCheckboxFieldComponent extends CheckboxesFieldComponent implements OnDestroy, OnChanges, OnInit {
    defaultNetworkOptions: CheckboxOptionModel[] = [
        new CheckboxOptionModel(`MediaType.${MediaTypeEnum.TWITTER}`, MediaTypeEnum.TWITTER),
        new CheckboxOptionModel(`MediaType.${MediaTypeEnum.FACEBOOK}`, MediaTypeEnum.FACEBOOK),
        new CheckboxOptionModel(`MediaType.${MediaTypeEnum.INSTAGRAM}`, MediaTypeEnum.INSTAGRAM),
        new CheckboxOptionModel(`MediaType.${MediaTypeEnum.YOUTUBE}`, MediaTypeEnum.YOUTUBE),
        new CheckboxOptionModel(`MediaType.${MediaTypeEnum.REDDIT}`, MediaTypeEnum.REDDIT),
        new CheckboxOptionModel(`MediaType.${MediaTypeEnum.LINKEDIN}`, MediaTypeEnum.LINKEDIN),
        new CheckboxOptionModel(`MediaType.${MediaTypeEnum.BLUESKY}`, MediaTypeEnum.BLUESKY)
    ];

    showError: boolean = false;
    showSection: boolean = true;

    subscriptions: Subscription[] = [];

    constructor(private monitorConfigService: MonitorConfigService) {
        super();
    }

    ngOnInit(): void {
        if (this.field.options?.length === 0) {
            this.field.options = this.defaultNetworkOptions;
        }
        this.subscriptions.push(
            this.monitorConfigService.getAvailableMediaTypes().subscribe((availableMediaTypes) => {
                if (availableMediaTypes) {
                    if (availableMediaTypes.includes(MediaTypeEnum.TIKTOK)) {
                        this.field.options.push(
                            new CheckboxOptionModel(`MediaType.${MediaTypeEnum.TIKTOK}`, MediaTypeEnum.TIKTOK)
                        );
                    }
                }
                this.setDefaultValue();
            })
        );
    }

    ngOnChanges(): void {
        if (this.field.appearCondition) {
            this.showSection = this.field.appearCondition(this.block.displayElement);
        }
    }

    setDefaultValue() {
        if (!this.block?.id && !this.value) {
            this.value = this.field.options.map(option => option.key);
        }
        this.changes.emit(this.value);
    }

    onCheckboxChanged(event) {
        this.changes.emit(event);
        if (this.value?.length === 0) {
            this.showError = true;
        } else {
            this.showError = false;
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(sub => sub.unsubscribe());
        this.field.options = [];
    }
}
